import { render } from "./paired-comparison-v1-compare-card.vue?vue&type=template&id=baad7fe0"
import script from "./paired-comparison-v1-compare-card.vue?vue&type=script&lang=js"
export * from "./paired-comparison-v1-compare-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__